import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom'
import { adminRoute, authRoutes, routes } from './routes'
import AdminLayout from './admin/components/AdminLayout'
import Navbar from './public/components/Navbar'
import Footer from './public/components/Footer'
import './i18n'
import { CurrencyProvider } from './util/CurrencyContext'
import { PageTitleProvider } from './shared/components/PageTitleContext'
import PageTitleUpdater from './shared/components/PageTitleUpdater'
import { CartProvider } from './util/CartContext'
import { useTranslation } from 'react-i18next'
import { TranslationProvider } from './util/TranslationContext'
import { useEffect } from 'react'
import { languageUtil } from './util/languageUtils'

function PublicLayout() {
    return (
        <>
            <CurrencyProvider>
                <Navbar />
                <main className='min-h-screen '>
                    <Outlet />
                </main>
                <Footer />
            </CurrencyProvider>
        </>
    )
}
export default function App() {
    const { t } = useTranslation()
    const { language } = languageUtil()

    useEffect(() => {
        document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr')
    }, [language])

    return (
        <TranslationProvider t={t}>
            <PageTitleProvider>
                <CartProvider>
                    <Router>
                        <PageTitleUpdater />
                        <Routes>
                            {/* Public routes with PublicLayout */}
                            <Route element={<PublicLayout />}>
                                {routes.map(route => (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={route.element}
                                    />
                                ))}
                            </Route>

                            {/* Admin login route WITHOUT layout */}
                            <Route path={adminRoute.path} element={adminRoute.element} />

                            {/* Authenticated admin routes WITH AdminLayout */}
                            <Route element={<AdminLayout />}>
                                {authRoutes.map(route => (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={route.element}
                                    />
                                ))}
                            </Route>
                        </Routes>
                    </Router>
                </CartProvider>
            </PageTitleProvider>
        </TranslationProvider>
    )
}
